import * as React from 'react'
import { StoreProps, castingStoreGetSelectedOptionJoined } from '../../../../services/stores/casting.store'
import QuotationFormComponent from '../../../backoffice/quotations/form/quotation-form.component'
import { employeeInformationActiveDirectPayment } from '../../../../services/models/employee-informations.service'

export default function CastingEmployeeQuotationFormComponent ({ data, store }: StoreProps) {
  const { market, offeredService, quotation: employeeQuotation, backofficePreselectedEmployee, castingType } = data
  
  const isDirectlyPaid = React.useMemo(() => {
    return employeeInformationActiveDirectPayment({
      employeeInformation: backofficePreselectedEmployee.employee_information,
      market,
      offeredService
    })
  }, [backofficePreselectedEmployee.employee_information, market, offeredService])

  const optionPrices = React.useMemo(() => {
    return castingStoreGetSelectedOptionJoined(data).reduce((acc, { offeredOption, selectedOption }) => {
      if (offeredOption.option_type === 'given_quantity' && offeredOption.fixed_price_from) {
        return {
          withTax: acc.withTax + offeredOption.fixed_price_from.with_tax * selectedOption.selected_value,
          withoutTax: acc.withoutTax + offeredOption.fixed_price_from.without_tax * selectedOption.selected_value
        }
      }

      return acc
    }, { withTax: 0, withoutTax: 0 })
  }, [data])
  
  const nestedProps = React.useMemo(() => ({
    castingMarket: market,
    currentUserMarket: market,
    casting: {
      casting_type: castingType,
      rentable_unit_of_work: offeredService.rentable_unit_of_work,
      price_of_options_adding_price: { price_cents: optionPrices.withoutTax * 100, tax_cents: (optionPrices.withTax - optionPrices.withoutTax) * 100 }
    },
    offeredService,
    quotation: employeeQuotation,
    onChange: (body: Partial<StoreProps['data']['quotation']>) => store.set({ quotation: { ...employeeQuotation, ...body } }),
    taxRate: offeredService.vat_price_percentage,
    isNoVat: isDirectlyPaid ? backofficePreselectedEmployee.employee_information.no_vat : market.no_vat,
    noBox: true
  }), [backofficePreselectedEmployee.employee_information.no_vat, castingType, employeeQuotation, isDirectlyPaid, market, offeredService, optionPrices.withTax, optionPrices.withoutTax, store])

  React.useEffect(() => {
    if (employeeQuotation) return

    store.set({
      quotation: {
        price_cents: null,
        round_on_vat_price: true,
        vat_price_cents: null,
        signable: offeredService.casting_custom_price_signed_by_default && market['online_sign?'],
        description: null,
        use_specific_increases: false,
        item_quotations_attributes: offeredService.rentable_unit_of_work === 'casting'
          ? [{ description: null, kind: 'service' as const, quantity: null, price_cents: null, tax_rules_group_id: null, verbose_description: null }]
          : []
      }
    })
  }, [employeeQuotation, market, offeredService.casting_custom_price_signed_by_default, offeredService.rentable_unit_of_work, store])

  if (!employeeQuotation) return null

  return <QuotationFormComponent { ...nestedProps } offeredServiceSubscription={ null } />
}
